import { Flags } from "../interfaces/Flags";
import { STATUS } from '../../../enum/status/Status';

const status: Flags[] = [
    { label: 'Em Diagnostico', value: STATUS.Diagnosis },
    { label: 'Em Resolução', value: STATUS.Resolution },
];

export default status